export default {
  items: [
    {
      title: true,
      name: 'Management',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
    name: 'Admin Users',
    url: '/admin',
    icon: 'icon-book-open',
    children: [
      {
        name: 'Edit User',
        url: '/admin/edit-user'
      },
      {
        name: 'Edit Roles',
        url: '/admin/edit-roles'
      },
      {
        name: 'Edit Permissions',
        url: '/admin/edit-permissions'
      }
    ]
    },
    {
      title: true,
      name: 'Media',
      class: '',
      wrapper: {
        element: '',
        attributes: {}
      }
    },
    {
      name: 'Management',
      url: '/man',
      icon: 'icon-book-open',
      children: [
        {
          name: "Campaigns",
          url: "/man/campaigns"
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_nav.js